module.exports = __webpack_public_path__ + "static/hybrid-vtol-propulsion-thrust-lift-distribution-technical-3757f001cc6e77826182a540f9b93564.webp";